import { lt, showSuccessAlert } from '@mews/framework';
import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { DataTestId } from '@mews-commander/enums';
import { useCentralPaymentPolicyDelete } from '../mutations';

interface Params {
    onSuccess?: () => void;
    paymentPolicyId: string;
    isAssignedToRateGroups: boolean;
}
export const useDeleteCentralPaymentPolicyDialog = ({ isAssignedToRateGroups, onSuccess, paymentPolicyId }: Params) => {
    const { mutateAsync } = useCentralPaymentPolicyDelete();
    const deleteAction = async () =>
        mutateAsync(
            { centralPaymentPolicyIds: [paymentPolicyId] },
            {
                onSuccess: () => {
                    onSuccess?.();
                    showSuccessAlert({
                        title: lt('PaymentPolicyDeletedSuccessMessage'),
                    });
                },
            }
        );
    const { confirmationDialog, openConfirmationDialog } = useDeleteConfirmationDialog({
        confirmButtonDataTestId: DataTestId.ConfirmDeletePolicyButton,
        deleteAction,
        renderContent: () =>
            isAssignedToRateGroups
                ? lt('PaymentPolicyDeleteDialogContent')
                : lt('PaymentPolicyDeleteDialogZeroEntitiesContent'),
        title: lt('PaymentPolicyDeleteDialogTitle'),
    });

    return { confirmationDialog, openConfirmationDialog };
};
